<div fxAlign="row" *ngIf="data">
  <div fxFlex>
    {{data?.message?.title}}
  </div>
  <div fxFlex fxLayoutAlign="end center">
    <button kendoButton [primary]="true" (click)="accept($event)">Accept</button>
    <button kendoButton [primary]="false" (click)="decline($event)">Decline</button>
  </div>
</div>
